// Default filter the WO Fees accordion (and the linked General Fees popovers) send to the
// pricing service to fetch the eligible per-instance, active, sub-item general fees.
export const generalFeeDefaultFilter = {
  requestedPage: 0,
  requestedPageSize: 200,
  searchFilters: [
    { columnName: 'periodText', columnValue: '1 Instance', operation: 'EQUAL_TO' },
    { columnName: 'isSubItem', columnValue: true, operation: 'EQUAL_TO' },
    { columnName: 'active', columnValue: true, operation: 'EQUAL_TO' },
  ],
  sortRules: [],
}

export const buildWorkOrderGeneralFeeFilter = (workOrderId: string) => ({
  ...generalFeeDefaultFilter,
  workOrderId,
})
